import React from "react";
import { Link } from 'react-router-dom';

const Terms = () => {

    const today = new Date().toLocaleDateString('en-ZA', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    });



    return (
        <div className="max-w-4xl mx-auto px-6 py-12 text-[#144E73]">
            <h1 className="text-3xl md:text-4xl font-bold mb-6">Terms & Conditions</h1>
            <p className="text-sm text-gray-600 mb-6">Last updated: {today}</p>

            <div className="space-y-6 text-sm md:text-base leading-relaxed">
                <section>
                    <h2 className="font-semibold text-lg mb-2">1. Introduction</h2>
                    <p>
                        Welcome to Benecke Group. These Terms & Conditions govern your use
                        of our website and services, including accommodation bookings,
                        property rentals, and dining experiences. By accessing our site or
                        using our services, you agree to these terms.
                    </p>
                </section>

                <section>
                    <h2 className="font-semibold text-lg mb-2">2. Services Overview</h2>
                    <p>
                        Benecke Group provides:
                        <ul className="list-disc pl-5 mt-2">
                            <li>Accommodation for individuals, families, and corporate guests</li>
                            <li>Property rentals, both residential and commercial</li>
                            <li>Dining services through associated restaurants</li>
                        </ul>
                        All services are subject to availability and confirmation.
                    </p>
                </section>

                <section>
                    <h2 className="font-semibold text-lg mb-2">3. Bookings & Payments</h2>
                    <p>
                        All bookings must be confirmed via our website, phone, or in
                        person. A valid form of payment (card, EFT, etc.) may be required
                        to secure a booking. Benecke Group reserves the right to cancel or
                        modify reservations if fraud or misuse is suspected.
                    </p>
                </section>

                <section>
                    <h2 className="font-semibold text-lg mb-2">4. Cancellations & Refunds</h2>
                    <p>
                        <ul className="list-disc pl-5 mt-2">
                            <li>Cancellations made within 48 hours of check-in may not be eligible for refunds.</li>
                            <li>Rental agreements require 30 days’ written notice unless stated otherwise.</li>
                            <li>Dining reservations can be cancelled freely, but repeated no-shows may result in restrictions.</li>
                        </ul>
                    </p>
                </section>

                <section>
                    <h2 className="font-semibold text-lg mb-2">5. Use of Website</h2>
                    <p>
                        You agree not to misuse our website, upload malicious content, or
                        infringe on any intellectual property. All images, logos, and
                        content are the property of Benecke Group and may not be reproduced
                        without permission.
                    </p>
                </section>

                <section>
                    <h2 className="font-semibold text-lg mb-2">6. Privacy & Data Protection</h2>
                    <p>
                        We respect your privacy. Information collected via our site is protected in line with South African POPIA standards. See our
                        <Link to="/privacy" className="underline text-blue-600 ml-1">Privacy Policy</Link> for more.
                    </p>
                </section>

                <section>
                    <h2 className="font-semibold text-lg mb-2">7. Limitation of Liability</h2>
                    <p>
                        Benecke Group will not be liable for any indirect or consequential
                        damages. Our liability is limited to the amount paid by you for the
                        service in question.
                    </p>
                </section>

                <section>
                    <h2 className="font-semibold text-lg mb-2">8. Guest Responsibilities</h2>
                    <p>
                        Guests are expected to:
                        <ul className="list-disc pl-5 mt-2">
                            <li>Respect staff, property, and other guests</li>
                            <li>Follow check-in/check-out policies</li>
                            <li>Refrain from illegal activity or property damage</li>
                        </ul>
                        Failure to comply may result in removal or legal action.
                    </p>
                </section>

                <section>
                    <h2 className="font-semibold text-lg mb-2">9. Force Majeure</h2>
                    <p>
                        Benecke Group will not be held responsible for service failures due
                        to events beyond our control, including natural disasters,
                        pandemics, or power outages.
                    </p>
                </section>

                <section>
                    <h2 className="font-semibold text-lg mb-2">10. Governing Law</h2>
                    <p>
                        These terms are governed by South African law. Disputes will be
                        resolved in the courts of Gauteng.
                    </p>
                </section>

                <section>
                    <h2 className="font-semibold text-lg mb-2">11. Contact Us</h2>
                    <p>
                        <strong>Address:</strong> Office Suite 1, Pasteur Court, 201 Pasteur Blvd, Vanderbijlpark<br />
                        <strong>P.O. Box:</strong> 6269, Vanderbijlpark, 1900, South Africa<br />
                        <strong>Tel:</strong> +27 (0) 16 940 4444<br />
                        <strong>Fax:</strong> +27 (0) 11 252 9219<br />
                        <strong>Email:</strong> <a href="mailto:mrd@wol.co.za" className="underline text-blue-600">mrd@wol.co.za</a>
                    </p>
                </section>

                <section>
                    <h2 className="font-semibold text-lg mb-2">12. Changes to These Terms</h2>
                    <p>
                        We may update these Terms & Conditions at any time. Please check
                        this page periodically for the latest version.
                    </p>
                </section>
            </div>
            <a
                href="/Benecke-Terms-and-Conditions.pdf"
                download
                className="inline-block bg-[#F29E38] text-[#023059] px-6 py-2 rounded-full font-semibold shadow hover:bg-opacity-90 transition mt-8"
            >
                Download PDF
            </a>

        </div>
    );
};

export default Terms;
